module.exports = __webpack_public_path__ + "img/amazake_main.cb179ff4.jpg";